<template>
    <div class="thread-header w-100 d-flex justify-content-between">
        <div></div>
        <div class="thread-date">
            {{ formatDateToLocalBasedOnDayMode(thread.createdOn) }}
        </div>
        <div v-if="thread">
            <span :class="`status-pill status-pill-${thread.conversationThreadStatus}`">{{
                ThreadStatus.getDescriptionUsingValue(thread.conversationThreadStatus)
            }}</span>
            <span
                class="dropdown ms-2"
                v-if="thread.conversationThreadStatus !== ThreadStatusEnum.Resolved && canEditPatient"
            >
                <span class="cursor-pointer" data-bs-toggle="dropdown" aria-expanded="false"
                    ><img src="../../../../../assets/images/chat/down-arrow.png" />
                    <ul class="dropdown-menu">
                        <li @click="handleResolve"><a class="dropdown-item" href="#">Mark as Resolved</a></li>
                    </ul></span
                >
            </span>
        </div>
    </div>
    <div class="thread-card">
        <!-- Original message (static, never scrolls) -->
        <div class="thread-message thread-message-original">
            <!-- Header row -->
            <div class="message-header">
                <div class="sender-info">
                    <div :class="`ava-initials ava-initials-${getSolutionClassIndex(1)}`">
                        <span class="weight-600">{{ formatUserInitials(thread?.createdByUser) }}</span>
                    </div>

                    <div>
                        <div class="sender-name">
                            {{ formatDisplayUsers([thread?.createdByUser]) }}
                            <span class="sender-meta">
                                {{
                                    thread.createdByUser?.relationship ? `  (${thread.createdByUser.relationship})` : ""
                                }}
                            </span>
                        </div>
                        <div class="sender-meta">{{ patientAgencyName }}</div>
                    </div>
                </div>

                <div class="message-time pe-1">
                    {{ formatDateTimeToLocal(thread.createdOn) }}
                </div>
            </div>

            <!-- Subject only for first message -->
            <div
                v-if="thread.subject"
                class="message-subject"
                v-html="sanitizeMarkup(markdownToHtml(thread.subject))"
            ></div>

            <!-- Body -->
            <div class="message-body" v-html="sanitizeMarkup(markdownToHtml(thread.body))"></div>
        </div>

        <!-- Replies (scrollable) -->
        <div
            class="thread-replies pe-2"
            :class="{ 'custom-scrollbar': userOs == 'Windows' }"
            ref="threadMessages"
            v-if="thread.messages?.length > 0 || showLoadMoreReplies"
        >
            <div v-if="showLoadMoreReplies" class="load-more-replies" @click="loadMoreMessages">
                Open {{ remainingRepliesCount }} more replies
            </div>
            <div v-for="(message, index) in thread.messages" :key="message.id" class="thread-message">
                <div class="message-header">
                    <div class="sender-info">
                        <div :class="`ava-initials ava-initials-${getSolutionClassIndex(index)}`">
                            <span class="weight-600">
                                {{ formatUserInitials(message?.senderUser) }}
                            </span>
                        </div>

                        <!-- Right side text column -->
                        <div class="message-text">
                            <div class="sender-name">
                                {{ formatDisplayUsers([message.senderUser]) }}
                            </div>
                            <div class="sender-meta">
                                {{
                                    message.senderUser?.isFamilyPortalUser
                                        ? message.senderUser?.relationship
                                            ? message.senderUser.relationship
                                            : patientAgencyName
                                        : "&nbsp;"
                                }}
                            </div>

                            <!-- Body under name -->
                            <div class="message-body" v-html="sanitizeMarkup(markdownToHtml(message.body))"></div>
                        </div>
                    </div>

                    <div class="message-time">
                        {{ formatDateTimeToLocal(message.createdOn) }}
                    </div>
                </div>
            </div>
        </div>

        <!-- Reply -->
        <template v-if="thread.conversationThreadStatus !== ThreadStatusEnum.Resolved && canEditPatient">
            <div class="reply-section" v-if="!showReply">
                <button class="reply-link" @click="handleshowReply">Reply to thread</button>
            </div>
            <div class="reply-input-wrapper" v-if="showReply">
                <div class="w-100 cursor-pointer text-end pe-2" @click="showReply = false">Cancel</div>
                <MessageInputHandler
                    :send="sendMessage"
                    :threadId="thread.id"
                    :refs-name="`threadEditorRef-${thread.id}`"
                    :toggle-important="toggleImportant"
                    :isFamilyPortal="true"
                />
            </div>
        </template>
    </div>
</template>
<style src="./FPThreadsCard.scss" />
<script lang="ts" src="./FPThreadsCard.ts" />
